const ArchiveReason: (t: any) => string[] = (t: any) => [
  t("noLongerNeeded"),
  t("completedOrFinalized"),
  t("duplicateEntry"),
  t("historicalReference"),
  t("legalOrComplianceRequirement"),
  t("dataQualityIssue"),
  t("businessRuleChange"),
  t("userRequested"),
  t("inactiveOrDormant"),
  t("itIsIncorrectAndCantUpdateIt"),
]
export const Constants = (t: any) => ({
  ArchiveReason: [...ArchiveReason(t)],

  UserArchiveReason: [
    ...ArchiveReason(t),
    t("userTerminated"),
    t("user_resigned"),
  ],
})

export const decodeMonth = (month: string) => {
  switch (month) {
    case "01":
      return "January"
    case "02":
      return "February"
    case "03":
      return "March"
    case "04":
      return "April"
    case "05":
      return "May"
    case "06":
      return "June"
    case "07":
      return "July"
    case "08":
      return "August"
    case "09":
      return "September"
    case "10":
      return "October"
    case "11":
      return "November"
    default:
      return "December"
  }
}
